import { useCallback, useEffect, useState } from "react";
import { client } from "@/lib/api";

export function useAdminData() {
  const [families, setFamilies] = useState([]);
  const [payments, setPayments] = useState([]);
  const reload = useCallback(async () => {
    const api = client("admin");
    const [f, p] = await Promise.all([api.get("/admin/families"), api.get("/admin/payments")]);
    setFamilies(f.data);
    setPayments(p.data);
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return { families, payments, reload };
}
